import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { FLAT_RATE_PLANS, flatRatePlanNames } from "@common/flatRateBilling";
import { Tag } from "@design-system/Tag/Tag";
import { ClientsCloseOverviewRow } from "../clientsCloseOverviewViewConfig";

export const ClosePlanCell = memo(
    ({
        getValue,
        row,
    }: CellContext<
        ViewTableFeatures,
        ClientsCloseOverviewRow,
        FLAT_RATE_PLANS | null
    >) => {
        if (row.original.rowType !== "workspace") {
            return null;
        }

        const value = getValue();

        if (!value) {
            return <span aria-label="No plan">-</span>;
        }

        const planName = flatRatePlanNames[value] ?? "Custom";

        return (
            <Tag color="neutral" outline>
                {planName}
            </Tag>
        );
    },
);

ClosePlanCell.displayName = "ClosePlanCell";
